import { DialogComponent } from '@theme/dialog';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that manages a klaviyo bis drawer.
 *
 * @extends {DialogComponent}
 */
class KlaviyoDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    this.variantId = this.dataset.variantId
    document.addEventListener(ThemeEvents.variantUpdate, this.onVariantChange.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  onVariantChange(e) {
    const { title, id } = e.detail.resource

    this.variantId = id
    if (this.refs.variantTitle) this.refs.variantTitle.innerHTML = title

    this.querySelector('.klaviyo-drawer__image').innerHTML = e.detail.data.html.querySelector('klaviyo-drawer-component .klaviyo-drawer__image').innerHTML
  }

  async onSubmit() {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
                type: 'profile',
                attributes: {
                    email: this.refs.emailInput.value,
                }
            }
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${this.variantId}`
            }
          }
        }
      }
    }

    const result = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.klaviyoKey}`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-06-15'
      },
      body: JSON.stringify(payload),
    })

    if (result.status === 202) {
      this.refs.signupForm.classList.add('hidden')
      this.refs.statusContainer.classList.remove('hidden')
      this.refs.errorMessage.classList.add('hidden')
    } else {
      this.refs.errorMessage.classList.remove('hidden')

      const errors = await result.json()
      const messages = errors.errors.map(error => error.detail)

      this.refs.errorMessage.innerHTML = messages.join('\n')
    }
  }
}

if (!customElements.get('klaviyo-drawer-component')) {
  customElements.define('klaviyo-drawer-component', KlaviyoDrawerComponent);
}
